<style lang="scss" scoped>
.slide-8 {
  background-image: url(../../../assets/module2/slide8/background-01.jpg);
  background-position: center;
  background-size: cover;
  padding-top: 60px;
  height: calc(100% - 60px);

  h1 {
    position: relative;
  }
  h2 {
    font-size: 45px;
  }
  p {
    color: white;
    margin-bottom: 1em;
  }
  .bend {
    position: relative;
  }
  .bend-letter {
    height: 300px;
    position: absolute;
    width: 20px;
    left: 0;
    top: 0;
    transform-origin: bottom center;
    &:nth-child(1) {
      transform: rotate(6deg);
    }
    &:nth-child(2) {
      transform: rotate(12deg);
    }
    &:nth-child(3) {
      transform: rotate(18deg);
    }
    &:nth-child(4) {
      transform: rotate(24deg);
    }
    &:nth-child(5) {
      transform: rotate(30deg);
    }
    &:nth-child(6) {
      transform: rotate(36deg);
    }
    &:nth-child(7) {
      transform: rotate(42deg);
    }
    &:nth-child(8) {
      transform: rotate(48deg);
    }
  }
  .black {
    color: #000;
  }
  .blue {
    color: #09509c;
  }
  .heading8 {
    font-size: 45px;
  }
}
</style>

<template>
  <div class="slide-8">
    <transition name="fadeUp" appear>
      <img
        class="chars delay-3"
        v-show="slideIndex == 7"
        src="@/assets/module2/slide8/frank-01.png"
      />
    </transition>

    <transition name="fadeRight" appear>
      <img
        class="chars delay-3"
        v-show="slideIndex == 7"
        src="@/assets/module2/slide8/photo-01.png"
      />
    </transition>
    <div class="pages">
      <div class="page page-left">
        <transition name="fadeLeft" appear>
          <div v-show="slideIndex == 7">
            <p>{{ $t("module2.slide8.precopy") }}</p>
          </div>
        </transition>
        <transition name="scale" appear>
          <div v-show="slideIndex == 7">
            <h1>{{ $t("module2.slide8.heading1") }}</h1>
            <h1>{{ $t("module2.slide8.heading2") }}</h1>
            <h1>
              <span class="black">evil clot</span>
              {{ $t("module2.slide8.heading3") }}
            </h1>
            <h1>{{ $t("module2.slide8.heading4") }}</h1>
            <h1>{{ $t("module2.slide8.heading5") }}</h1>
            <h1>{{ $t("module2.slide8.heading6") }}</h1>
            <h1>
              {{ $t("module2.slide8.heading7") }}
              <span class="bend">
                <span class="content-bend">
                  &nbsp;
                  <span class="bend-letter">d</span>
                  <span class="bend-letter">r</span>
                  <span class="bend-letter">o</span>
                  <span class="bend-letter">o</span>
                  <span class="bend-letter">p</span>
                  <span class="bend-letter">i</span>
                  <span class="bend-letter">n</span>
                  <span class="bend-letter">g.</span>
                </span>
              </span>
            </h1>
          </div>
        </transition>
      </div>
      <div class="page page-right">
        <transition name="fadeRight" appear>
          <div class="delay-1" v-show="slideIndex == 7">
            <p>{{ $t("module2.slide8.copy1") }}</p>
          </div>
        </transition>
        <transition name="fadeRight" appear>
          <div class="delay-2" v-show="slideIndex == 7">
            <h1 class="heading8">
              <span class="blue">{{ $t("module2.slide8.heading8") }} </span>
              {{ $t("module2.slide8.heading9") }}
            </h1>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
